module.exports = __webpack_public_path__ + "img/text-classification.024ca0a1.gif";